import PermIdentity from '@material-ui/icons/PermIdentity';
import {PaymentList} from "./PaymentList";
import {PaymentCreate} from "./PaymentCreate";
import {PaymentEdit} from "./PaymentEdit";
// import {
//     ShowGuesser,
//     // EditGuesser
// } from 'react-admin';


// import {BaseListIdNameEdit} from "./BaseListIdNameEdit";
// import {BaseListIdNameCreate} from "./BaseListIdNameCreate";

const resource = {
    list: PaymentList,
    create: PaymentCreate,
    edit: PaymentEdit,
    // show: ShowGuesser,
    icon: PermIdentity,
};

export default resource;